import { gql } from '@apollo/client'

export const CREATE_DISCOUNT_PLAN = gql`
    mutation createShareAndDiscount($share_and_discount: ShareAndDiscountInput!) {
        createShareAndDiscount(share_and_discount: $share_and_discount) {
            code
            success
            message
                }
            }
        `

export const UPDATE_DISCOUNT_PLAN =  gql`
            mutation updateShareAndDiscount($id: NonEmptyString!, $share_and_discount: ShareAndDiscountInput!) {
                updateShareAndDiscount(id: $id, share_and_discount: $share_and_discount) {
                    code
                    success
                    message
                }
            }
        `;
 

export const ACTIVATE_DISCOUNT_PLAN = gql`
        mutation UpdateShareAndDiscountStatus($updateShareAndDiscountStatusId: NonEmptyString!, $discountStatus: DiscountStatus!) {
            updateShareAndDiscountStatus(id: $updateShareAndDiscountStatusId, discount_status: $discountStatus) {
                code
                success
                message
            }
        }
    `;

